import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import SelectCreator from "../../../components/Forms/components/SelectCreator";
import {requestCustomFieldChoicesLabelValue} from "../../../redux/Actions/customFields.actions";
import {customFieldChoicesLabelValue} from "../../../redux/Selectors/customFields.selector";

const ChoiceSets = (props) => {
  const {isDisabled, onChange, value} = props;
  const dispatch = useDispatch();
  const choiceOptions = useSelector(customFieldChoicesLabelValue);

  useEffect(() => {
    dispatch(requestCustomFieldChoicesLabelValue());
  }, [dispatch]);

  return (
    <SelectCreator
      classNamePrefix={"choice-set"}
      id={"choice-set"}
      isDisabled={isDisabled}
      isRequired
      inSingleRow
      label="Choices"
      large
      name="choice_set"
      onChange={onChange}
      options={choiceOptions}
      value={value}
    />
  );
};

export default ChoiceSets;
